import React, { useState } from 'react';
import axios from 'axios';

export default function EbookVenda() {
  const [form, setForm] = useState({ nome: '', email: '' });
  const [enviado, setEnviado] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('/enviar_ebook.php', form);
      setEnviado(true);
    } catch (err) {
      alert('Erro ao enviar. Tente novamente.');
    }
  };

  return (
    <div className="min-h-screen bg-orange-50 flex flex-col items-center justify-center p-6">
      <div className="max-w-xl bg-white shadow-xl rounded-2xl p-6 text-center">
        <img src="/images/banana_da_terra_capa.png" alt="Ebook Banana da Terra" className="w-full rounded-xl mb-4" />
        <h1 className="text-3xl font-bold mb-2 text-orange-800">Banana da Terra na Cozinha</h1>
        <p className="text-yellow-600 font-semibold mb-4">40+ receitas naturais e veganas</p>
        <p className="mb-6 text-gray-700">Aprenda com o Chef Pitchou Luambo a transformar banana da terra em pratos incríveis e saudáveis!</p>
        <a href="https://mpago.la/2V5Njxy" target="_blank" rel="noopener noreferrer" className="bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-2 px-6 rounded-xl transition duration-300 inline-block mb-6">
          Comprar agora por R$ 29,90
        </a>
        {!enviado ? (
          <form onSubmit={handleSubmit} className="space-y-4">
            <input
              type="text"
              placeholder="Seu nome"
              className="w-full p-3 border border-gray-300 rounded-xl"
              value={form.nome}
              onChange={(e) => setForm({ ...form, nome: e.target.value })}
              required
            />
            <input
              type="email"
              placeholder="Seu e-mail"
              className="w-full p-3 border border-gray-300 rounded-xl"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              required
            />
            <button type="submit" className="bg-orange-600 hover:bg-orange-700 text-white py-2 px-6 rounded-xl font-bold">
              Receber e-book por e-mail
            </button>
          </form>
        ) : (
          <p className="text-green-600 font-semibold mt-4">E-book enviado com sucesso!</p>
        )}
      </div>
    </div>
  );
}
